import { render } from "./previewImg.vue?vue&type=template&id=56a5278a&scoped=true"
import script from "./previewImg.vue?vue&type=script&lang=js"
export * from "./previewImg.vue?vue&type=script&lang=js"

import "./previewImg.vue?vue&type=style&index=0&id=56a5278a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a5278a"]])

export default __exports__